export default __webpack_public_path__ + "static/media/sounds/click_ok.mp3";